import { Alert, Card, CardBody } from '@statsbomb/kitbag-components';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from 'styled-components';
import {
  videoSearchMatchDataAtom,
  videoSearchResultsErrorAtom,
  videoSearchResultsAtom,
} from '../../atoms/videoListings';
import { useClearSelections } from '../../hooks/clearSelectionsOnLoad';
import useVideoListings from '../../hooks/videoListings';
import themeHelper from '../../utils/themeHelper';
import CardHeader from '../CardHeader';
import MetadataSelections from '../MetadataSelections';
import VideoSearchActions from './VideoSearchActions';

const SelectionContainer = styled.div`
  display: flex;
  justify-content: left;
  gap: ${themeHelper.spacing()};
`;

const StyledSpan = styled.span`
  align-self: flex-end;
  min-width: 30vw;
  max-width: 60vw;
`;

export function VideoSearch() {
  const videoSearchResultsError = useAtomValue(videoSearchResultsErrorAtom);
  const setVideoSearchResults = useSetAtom(videoSearchResultsAtom);
  const setVideoSearchMatchData = useSetAtom(videoSearchMatchDataAtom);
  const { refreshVideoSearchResults } = useVideoListings();
  const { resetSelections } = useClearSelections();
  useEffect(() => {
    setVideoSearchResults([]);
    setVideoSearchMatchData(null);
    resetSelections(null, refreshVideoSearchResults);
  }, []);
  return (
    <>
      {videoSearchResultsError && (
        <Alert type="error">{videoSearchResultsError.text}</Alert>
      )}
      <Card>
        <CardHeader>
          <FormattedMessage
            defaultMessage="Match Details"
            id="9a779"
            description="Match Details"
          />
        </CardHeader>
        <CardBody>
          <SelectionContainer>
            <StyledSpan>
              <MetadataSelections.Sport />
            </StyledSpan>
            <StyledSpan>
              <MetadataSelections.MatchId id="matchId" required />
            </StyledSpan>
            <StyledSpan>
              <VideoSearchActions />
            </StyledSpan>
          </SelectionContainer>
        </CardBody>
      </Card>
    </>
  );
}

export default { VideoSearch };
